<header>
  <!-- Fixed navbar -->
  <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">GetLocal</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" i18n-aria-label aria-label="Navigation umschalten">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav align-items-center mb-2 mb-md-0" style="flex: 1 1 0;">
          <a class="py-2" href="#" i18n-aria-label aria-label="Produkt">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="d-block mx-auto" role="img"
              viewBox="0 0 24 24">
              <title i18n>Produkt</title>
              <circle cx="12" cy="12" r="10" />
              <path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83m13.79-4l-5.74 9.94" />
            </svg>
          </a>
        </ul>

        <div class="d-flex justify-content-center my-2 my-md-0" style="flex: 0 0 auto; min-width: 280px;">
          <app-search-bar class="w-100" (searchCriteria)="search($event)"></app-search-bar>
        </div>

        <div class="d-flex align-items-center justify-content-end" style="flex: 1 1 0;">
          <!-- #172: the searcher's location — the chip shows it, its dropdown changes it. -->
          <app-location-indicator class="me-2"></app-location-indicator>
          <!-- #652: the Merkliste is profile-scoped, so unlike the cart it is NOT gated on
               `profile?.customer` — that condition would hide it from the signed-in users it
               is for. The component decides for itself (it needs a profile, nothing more). -->
          <app-bookmark-info></app-bookmark-info>
          @if (profile?.customer) {
            <app-cart-info></app-cart-info>
          }
          <app-language-menu></app-language-menu>
          <app-login-menu></app-login-menu>
        </div>

      </div>
    </div>
  </nav>
</header>
